import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export const options = {
  responsive: true,

  plugins: {
    legend: {
      display: false
    },
    title: {
      display: false
    },

    tooltips: {
      position: 'nearest',
      mode: 'index',
      intersect: false,
      yPadding: 10,
      xPadding: 10,
      caretSize: 4,
      backgroundColor: '#1967d2',
      borderColor: 'rgba(0,0,0,1)',
      borderWidth: 4
    }
  }
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Dataset',
      data: labels.map(() => faker.number.int({ min: 100, max: 400 })),
      borderColor: '#1967d2',
      backgroundColor: '#1967d2',
      fill: false
    }
  ]
};

function ChartMain() {
  return (
    <div className="widget-content">
      <Line options={options} data={data} />
    </div>
  );
}

export default ChartMain;
